const STORAGE_KEY = "ghpPostPurchase";

function isValidPayload(payload) {
  if (!payload || typeof payload !== "object") {
    return false;
  }
  if (payload.version !== 1) {
    return false;
  }
  if (typeof payload.signedOrder !== "string" || payload.signedOrder.length === 0) {
    return false;
  }

  return !( typeof payload.backUrl !== "string" ||
    !payload.backUrl.startsWith( "/" ) ||
    payload.backUrl.startsWith( "//" ) );
}

function bind(root) {
  const cta = root.querySelector(".ghp-pp-offer__cta");
  if (!cta) {
    return;
  }
  const nextUrl = root.dataset.nextUrl || "#";

  cta.addEventListener("click", (event) => {
    event.preventDefault();

    const payload = window.ghpPostPurchase;
    if (!isValidPayload(payload)) {
      // eslint-disable-next-line no-console
      console.warn("[ghp-pp-offer] window.ghpPostPurchase is missing or invalid; aborting redirect.");
      return;
    }
    if (nextUrl === "#") {
      // eslint-disable-next-line no-console
      console.warn("[ghp-pp-offer] next-step URL is not configured; aborting redirect.");
      return;
    }

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (err) {
      // Quota / private-browsing mode. The redirect still proceeds — the
      // React app falls back to its empty-state path.
      // eslint-disable-next-line no-console
      console.warn("[ghp-pp-offer] sessionStorage write failed", err);
    }

    window.location.assign(nextUrl);
  });
}

document.querySelectorAll(".ghp-pp-offer").forEach(bind);
